import {client, database_id} from "../lib/appwrite";
import {v4 as uuidv4} from "uuid";
import {StaffItem} from "../types/staff";
import {Databases, Query} from "appwrite";

const STAFF_COLLECTION = "678b9f620013cef5fd15"
const databases = new Databases(client);

export const staffService = {

  async list(queries: string[] = [], limit: number = 100): Promise<StaffItem[]> {
    try {
      const response = await databases.listDocuments(
        database_id,
        STAFF_COLLECTION,
        [
          Query.limit(limit),
          ...queries
        ]
      );
      return response.documents.map(doc => doc as unknown as StaffItem);

    } catch (error) {
      // console.error('Error listing news:', error);
      throw error;
    }
  },

  async createStaff(data: StaffItem): Promise<StaffItem> {
    try {
      const createdItem = await databases.createDocument(
        database_id,
        STAFF_COLLECTION,
        uuidv4(),
        data
      ) as unknown as StaffItem;

      return createdItem;
    } catch (error) {
      // console.error('Помилка створення:', error); // change
      throw error;
    }
  },
  async updateStaff(data: StaffItem): Promise<StaffItem> {
    try {
      const id = data.$id as string
      const {$id, ...correctData} = data
      const updatedStaff = await databases.updateDocument(
        database_id,
        STAFF_COLLECTION,
        id,
        correctData
      ) as unknown as StaffItem;
      return updatedStaff;
    } catch (error) {
      console.log(error)
      console.error('Помилка оновлення лікаря!', error);
      throw error;
    }
  },

  async delete(id: string): Promise<void> {
    try {
      await databases.deleteDocument(
        database_id,
        STAFF_COLLECTION,
        id
      );
    } catch (error) {
      // console.error('Error deleting news:', error);
      throw error;
    }
  },
}